
import { Button } from "@/components/ui/button";

interface AssessmentControlsProps {
  onPrevious: () => void;
  onNext: () => void;
  onSkip: () => void;
  isFirstQuestion: boolean;
  isLastQuestion: boolean;
  currentAnswerSelected: boolean;
}

export const AssessmentControls = ({ 
  onPrevious, 
  onNext, 
  onSkip,
  isFirstQuestion, 
  isLastQuestion,
  currentAnswerSelected
}: AssessmentControlsProps) => {
  return (
    <div className="flex justify-between items-center mt-6">
      <div className="flex gap-2">
        <Button
          variant="outline"
          onClick={onPrevious}
          disabled={isFirstQuestion}
          className="border-[#0f2d69] text-[#0f2d69] hover:bg-[#0f2d69] hover:text-white"
        >
          Previous
        </Button>
        <Button 
          onClick={onNext}
          disabled={!currentAnswerSelected}
          className="bg-[#0f2d69] text-white hover:bg-[#0f2d69]/90"
        >
          {isLastQuestion ? "Finish" : "Next"}
        </Button>
      </div>
      <Button
        variant="ghost"
        onClick={onSkip}
        className="text-[#0f2d69] hover:bg-[#0f2d69]/10"
      >
        Skip to Results
      </Button>
    </div>
  );
};
